import React from 'react'
import { Auth0Service, LocalStorageService, UserService, ContractService, SessionService, ClientService } from '../services'
import { EmailConfirmation, SimpleLoading, VerifyContract, WithoutPasswordScreen, MessagePure } from './pures'
import { RegistrationAction, AppAction, RegisterUserInvitedAction, LoginAction, RegisterUserCollaboratorAction, ChangePasswordEmailAction, QRDocSignedAction, InvitedWoutPasswordAction, RequestOTPAction, NewUserOnboardingAction } from './actions'
import { UserTypeServiceAPI } from './views'
import { useTranslation } from 'react-i18next'
import appI18n from '../i18n'

class IndexComponent extends React.Component {
  state = {
    isLoading: false,
    isLogged: false,
    emailConfirmed: true,
    userRegistered: false,
    userIsInvited: false,
    userInvitedUpdateYourInfo: true,
    userIsColaborator: false,
    userColaboratorUpdateYourInfo: true,
    userInviteIsCreatingContract: false,
    unauthorized: false,
    userLogin: '',
    userStartSesion: false,
    loading: false,
    showLoadingRequesting: false,
    showCompletedRequesting: false,
    showErrorRequesting: false,
    showNotification: false,
    showRegisterCompleted: false,
    notificationStatus: 'success',
    canSendEmail: false,
    timerSesion: {},
    isEmailChangepassword: false,
    tokenEmailChange: '',
    userEmailChange: '',
    isQRDocsigned: false,
    sessionIdQR: '',
    hashQR: '',
    denyLogin: false,
    contractStatus: 0,
    withoutPasswordSign: false,
    userEmail: "",
    newUser: false,
    idSign: "",
    requestOTP: false,
    isValidUser: false,
    userTypeServiceApi: false,
    showNewUserOnboardingView: false,
    auth0Exist: false,
  }

  auth0Service = new Auth0Service()
  localStorageService = new LocalStorageService()
  userService = new UserService(process.env.REACT_APP_MIFIRMA_API)
  contractService = new ContractService(process.env.REACT_APP_MIFIRMA_API)
  sessionService = new SessionService(process.env.REACT_APP_MIFIRMA_API)
  clientService = new ClientService(process.env.REACT_APP_MIFIRMA_API)

  /* ===== Styles of notification alert component ===== */
  notification = {
    type: {
      style: this.state.notificationStatus,
      icon: true
    },
    style: {
      bottom: 85,
      right: 30,
      position: 'fixed'
    }
  }

  /* ===== Handler function for only close the notification ===== */
  onCloseOpenModal = () => {
    this.setState({
      showNotification: false,
      showCompletedRequesting: false,
    })
  }

  /* ===== Handler function for open and close the the notification with a timeOut ===== */
  handleMessage = (message) => {
    this.setState({
      // showNotification: true,
      showCompletedRequesting: true,
      message
    }, () => {
      setTimeout(() => {
        this.onCloseOpenModal()
      }, 5000)
    })
  }

  toggleCompletedRequesting = (value) => {
    this.setState({
      showCompletedRequesting: value
    }, () => {
      setTimeout(() => {
        this.setState({ showCompletedRequesting: false })
      }, 4000)
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value
    })
  }

  toggleErrorRequesting = (value) => {
    this.setState({
      showErrorRequesting: value,
    },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false })
        }, 4000)
      }
    )
  }

  /**
  * @author Alan Aguilar
  * @description Method to show the register completed dialog modal
  * @updatedDate 03-08-2021
  * @memberof SignatureRequestAction
  */
  toggleRegisterCompleted = (value) => {
    this.setState({ showRegisterCompleted: value })
    if (value === false) return this.onGoToMenu()
  }

  /**
  * @author Alan Aguilar
  * @description Redirect the user to the menu rechangin the page
  * @updatedDate 03-08-2021
  * @memberof SignatureRequestAction
  */
  onGoToMenu = () => {
    window.location.reload()
  }

  /**
   * @author Leonel Contreras
   * @description redirect to login
   * @memberof IndexAction
   */
  redirectLogin = async () => {
    let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
    let preferredLanguage = this.localStorageService.getLocalStorageItem("preferredLanguage")
    let promotion = await this.localStorageService.getLocalStorageItem('promotion')
    await this.localStorageService.clearLocalStorage()
    await this.localStorageService.setLocalStorageItem('clientLogo', logo)
    await this.localStorageService.setLocalStorageItem('preferredLanguage', preferredLanguage)
    if (promotion) {
      await this.localStorageService.setLocalStorageItem('promotion', promotion)
    }
    this.setState({ userStartSesion: false })
  }

  /**
  * @author Alan Aguilar
  * @description Set the state userRegistered to true to authorize the user register
  * @updatedDate 03-08-2021
  * @memberof IndexAction
  */
  onRegisterEnd = () => {
    console.log('onRegiserEnd')
    // this.setState({ userRegistered: true })
  }

  onLoadEmailConfirmation = async () => {
    try {
      let user = this.localStorageService.getLocalStorageItem('user')
      let token = this.localStorageService.getLocalStorageItem('token')
      let userAuth0Id = user.userMetaData.userAuth0.user_id.split('|')[1]
      let emailVerification = await this.sessionService.sessionEmailVerification(userAuth0Id, token.idToken)
      if (!emailVerification) return
      return true
    } catch (error) {
    }
  }

  /**
   * @author Leonel Contreras
   * @description send an email confirmation if the user has token
   * @param {boolean} sendEmail
   */
  onSendVerificationEmail = async (sendEmail) => {
    try {
      await this.toggleLoadingRequesting(true)
      if (sendEmail) {
        let user = this.localStorageService.getLocalStorageItem('user')
        let token = this.localStorageService.getLocalStorageItem('token')
        let userAuth0Id = user.userMetaData.userAuth0.user_id.split('|')[1]
        await this.sessionService.sessionEmailVerification(userAuth0Id, token.idToken)
        await this.toggleLoadingRequesting(false)
        await this.toggleCompletedRequesting(true)
      } else {
        window.location.reload()
      }
    } catch {
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  /**
  * @author Alan Aguilar
  * @description Redirect a invited user to register
  * @date 24-02-2021
  * @memberof IndexAction
  */
  onInvitedRedirectRegister = () => {
    this.setState({
      userRegistered: false,
      userIsInvited: false
    })
  }

  /**
   * @author Edgar Escobedo
   * @description Get info from URL, path, query params and route params
   * @createdDate 07-10-2025
   * @returns { {path: String, query: String, routeParams: Object} } Object with URL info
   */
  getUrlInfo = () => {
    const { href, pathname, search, hash } = window.location
    if (hash.startsWith('#/')) {
      const [path, q = ''] = hash.slice(1).split('?')
      return { url: href, path: path || '/', params: Object.fromEntries(new URLSearchParams(q)) }
    }
    return { url: href, path: pathname || '/', params: Object.fromEntries(new URLSearchParams(search)) }
  }

  async componentDidMount() {
    this.setState({ loading: true })
    let location = window.location
    let myStorage = window.localStorage
    let denyLogin = false
    const tabSelected = {
      buttonFilterSelectedBlue: 'table-button-blue-active',
      buttonFilterSelectedGreen: '',
    }

    myStorage.setItem('tabSelected', JSON.stringify(tabSelected))
    myStorage.setItem('tabSelectedReq', JSON.stringify(tabSelected))
    this.setState({ isLoading: true })

    // Save the signRequest url if exist
    let signRequestHash = location.href.split('#')[1]
    let urlIsFromSignRequest = (signRequestHash !== undefined || signRequestHash !== '/' || signRequestHash !== '') ? true : false
    if (urlIsFromSignRequest) this.localStorageService.setLocalStorageItem('url', location.href)

    let token = this.localStorageService.getLocalStorageItem('token')
    let user = this.localStorageService.getLocalStorageItem('user')
    let modules = this.localStorageService.getLocalStorageItem('modules')
    let promotion = this.localStorageService.getLocalStorageItem('promotion')
    let chargeId = this.localStorageService.getLocalStorageItem("chargeId");
    let chargeURL = this.localStorageService.getLocalStorageItem("chargeURL");
    let requestOTP = this.localStorageService.getLocalStorageItem("requestOTP");

    let userToken = null
    let userMetaData = null

    // Get URL info
    const urlInfo = this.getUrlInfo()


    // If user is Invite and he is creating a Contract, the user information and modules are deleted
    let inviteIsCreatingAContractUrl = location.href.split('?')[1]
    let inviteIsCreatingAContract = (inviteIsCreatingAContractUrl !== undefined && inviteIsCreatingAContractUrl !== '' && inviteIsCreatingAContractUrl.includes('id=')) ? true : false
    if (inviteIsCreatingAContract && user && user.userMetaData && user.userMetaData.userMifirma && user.userMetaData.userMifirma.userType.id === Number(process.env.REACT_APP_USER_TYPE_INVITADO)) {
      this.localStorageService.deleteElementLocalStorage('user')
      this.localStorageService.deleteElementLocalStorage('modules')
      user = null
      modules = null
      await this.setState({ userInviteIsCreatingContract: true })
    }

    //Verify if login request OTP
    this.setState({
      requestOTP
    })

    //Verify if is an email to change password
    let infoChangePassword = location.href.split('?')[1]
    // let existUserInfoChangePassword = (infoChangePassword !== undefined && infoChangePassword !== '' && infoChangePassword.includes('user=')) ? true : false
    let existInfoChangePassword = (infoChangePassword !== undefined && infoChangePassword !== '' && infoChangePassword.includes('token=')) ? true : false

    if (existInfoChangePassword) {
      let userInfoChangePasswordSplit = infoChangePassword.split('=')[1]
      // let userInfoChangePassword = userInfoChangePasswordSplit.split('&')[0]
      // userInfoChangePassword = userInfoChangePassword.trim()

      let tokenInfoChangePassword = userInfoChangePasswordSplit.trim()
      this.setState({
        isEmailChangepassword: true,
        tokenInfoChangePassword: tokenInfoChangePassword
        // userInfoChangePassword: userInfoChangePassword
      })
    }


    //verify if is an QRDocSigned
    let infoQRDocSigned = location.href.split('?')[1]
    let existQRSessionId = (infoQRDocSigned !== undefined && infoQRDocSigned !== '' && infoQRDocSigned.includes('id=')) ? true : false
    let existQRHash = (infoQRDocSigned !== undefined && infoQRDocSigned !== '' && infoQRDocSigned.includes('hash=')) ? true : false
    if (existQRSessionId && existQRHash) {
      let idQRSplit = infoQRDocSigned.split('=')[1]
      let sessionIdQR = idQRSplit.split('&')[0]
      sessionIdQR = sessionIdQR.trim()
      let hashQR = infoQRDocSigned.split('=')[2]

      this.setState({
        isQRDocsigned: true,
        sessionIdQR: sessionIdQR,
        hashQR: hashQR
      })
    }

    let signRequestOpen = location.href.split("#/")[1]
    let existSignRequestOpen = signRequestOpen && signRequestOpen.includes("sign-request-open")
    let existAllParameters
    let email
    if (existSignRequestOpen) {
      let emailSigner = infoQRDocSigned.split('=')[1]
      email = emailSigner.split('&')[0]
      email = email.trim()
      let idSign = infoQRDocSigned.split('=')[2]
      idSign = idSign
      existAllParameters = idSign && email
      this.setState({ withoutPasswordSign: true, userEmail: email, idSign })
    }

    // Validate if it is a new user without a password and without having created an account in Auth0
    const pathNewUserWithoutPassword = (urlInfo && urlInfo.path && urlInfo.path === '/user-register-invitation') ? true : false
    const emailEncryptedExist = (urlInfo && urlInfo.params && urlInfo.params.email) ? true : false
    const showNewUserOnboardingView = (pathNewUserWithoutPassword && emailEncryptedExist) ? true : false
    this.setState({ showNewUserOnboardingView })

    try {
      if (token && user && modules !== null) {
        // If a token exist, get user information from A3Cloud API and DigitalSignApp API
        userMetaData = await this.userService.getUser(user.userToken.sub, token.idToken)
        if (userMetaData == null) {
          this.setState({ isLogged: true, userRegistered: false, loading: false })
          return false
        }
        if (userMetaData.userA3Cloud === null || userMetaData.userMifirma === null) {
          this.setState({ isLogged: true, userRegistered: false, loading: false, userStartSesion: true })
          return false
        }

        // Start Local Storge
        user.userMetaData = userMetaData
        this.localStorageService.startLocalStorage(token, user, modules)
        if (!LocalStorageService.retrieveItem('preferredLanguage')) this.localStorageService.setLocalStorageItem("preferredLanguage", userMetaData.userMifirma.language.isoKey)
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.localStorageService.setLocalStorageItem('timezone', timezone)
        if (userMetaData) {
          this.setState({ emailConfirmed: userMetaData.userAuth0.email_verified })
          let contract = await this.contractService.validateContractUser(token.idToken)
          if (contract.data?.contractsStatus) {
            this.setState({ contractStatus: contract.data?.contractsStatus })
          }
          if (contract.data?.contractsStatus === 1) {
            this.setState({ denyLogin: true })
            await this.localStorageService.clearLocalStorage()
          }
          if (contract && contract.data && contract.data?.userHadContracts) {
            this.localStorageService.setLocalStorageItem("contractUserExist", contract);
          }

          // Check if the userType is invited
          if (userMetaData.userMifirma.userType.id === Number(process.env.REACT_APP_USER_TYPE_INVITADO)) {
            this.setState({ userIsInvited: true })
            // Check if the user has updated your information
            if (userMetaData.userA3Cloud.secondLastName === '' && userMetaData.userA3Cloud.address.id === Number(process.env.REACT_APP_ADDRESS_DEFAULT_ID)) {
              this.setState({ userInvitedUpdateYourInfo: false })
            }
          }

          // Check if the userType is colaborator
          if (userMetaData.userMifirma.userType.id === Number(process.env.REACT_APP_USER_TYPE_COLABORADOR) || userMetaData.userMifirma.userType.id === Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR)) {
            this.setState({ userIsColaborator: true })
            // Check if the user has updated your information
            let { firstName, firstLastName, secondLastName, phoneNumber, cellphoneNumber } = userMetaData.userA3Cloud
            if ((firstName === '') &&
              (firstLastName === '') &&
              (secondLastName === '') &&
              (phoneNumber === null || phoneNumber === '') &&
              (cellphoneNumber === null || cellphoneNumber === '')) {
              this.setState({ userColaboratorUpdateYourInfo: false })
            }
          }

          // Validate if the user has almost one contract
          if (contract.data && (contract.data.contractExist === true || contract.data.userHadContracts === true)) {
            this.setState({ userRegistered: true })
          }
          await this.setState({ userLogin: userMetaData.userMifirma.email, userStartSesion: true })
        }

        // Timer token session started
        this.localStorageService.timerSession(token)

        this.setState({ isLogged: true, loading: false })
        window.history.pushState('', document.title, window.location.pathname)

      } else if (token) {
        if (token.access_token) {
          userToken = await this.auth0Service.getUserProfile(token.access_token)
          userMetaData = await this.userService.getUser(userToken.sub, token.idToken)

          //Verify if user is type Servicio/Api
          // let type = (userMetaData && userMetaData.userMifirma && userMetaData.userMifirma.userType) ? userMetaData.userMifirma.userType : null
          // if (type && type[process.env.REACT_APP_USER_TYPE_SERVICE_API_FIELD_SEARCH] === process.env.REACT_APP_USER_TYPE_SERVICE_API_NAME) {
          //   this.setState({
          //     userTypeServiceApi: true,
          //     loading: false
          //   })

          //   return
          // }


          // // If user is Invite and he is creating a Contract, modfy the userMetadata information
          if (this.state.userInviteIsCreatingContract) {
            userMetaData.userA3Cloud = null
            userMetaData.userMifirma = ''
            userMetaData.userModules = ''
            userMetaData.userRoles = ''
          }

          if (userMetaData) {
            let languageSelected = this.localStorageService.getLocalStorageItem("preferredLanguage")
            let languageInDB = (userMetaData && userMetaData.userMifirma && userMetaData.userMifirma.language && userMetaData.userMifirma.language.isoKey) ? userMetaData.userMifirma.language.isoKey : null
            let languageCurrent = languageInDB
            if (languageSelected && languageInDB && languageInDB !== languageSelected) {
              languageCurrent = languageSelected
              await this.userService.updateLangageUser(languageSelected, token.idToken)
            }

            if (userMetaData.userMifirma) {
              this.props.i18n.changeLanguage(languageCurrent ?? process.env.REACT_APP_DEFAULT_LANGUAGE);
              this.localStorageService.setLocalStorageItem("preferredLanguage", languageCurrent ?? process.env.REACT_APP_DEFAULT_LANGUAGE)
            }

            this.setState({ emailConfirmed: userMetaData.userAuth0.email_verified, userStartSesion: true, canSendEmail: true })
            let contract = await this.contractService.validateContractUser(token.idToken)
            if (contract.data?.contractsStatus) {
              this.setState({ contractStatus: contract.data?.contractsStatus })
            }
            if (contract.data?.contractsStatus === 1) {
              this.setState({ denyLogin: true })
              denyLogin = true
            }
            if (contract && contract.data && contract.data?.userHadContracts) {
              this.localStorageService.setLocalStorageItem("contractUserExist", contract);
            }
            // // If user is Invite and he is creating a Contract, the user contract information is delete
            if (this.state.userInviteIsCreatingContract) {
              contract = null
            }

            // Check if the userType is invited
            if (userMetaData.userMifirma && userMetaData.userMifirma.userType && userMetaData.userMifirma.userType.id === Number(process.env.REACT_APP_USER_TYPE_INVITADO)) {
              this.setState({ userIsInvited: true })
              // Check if the user has updated your information
              if (userMetaData.userA3Cloud.secondLastName === '' && userMetaData.userA3Cloud.address.id === Number(process.env.REACT_APP_ADDRESS_DEFAULT_ID)) {
                this.setState({ userInvitedUpdateYourInfo: false })
              }
            }

            // Check if the userType is colaborator
            if (userMetaData.userMifirma && (userMetaData.userMifirma.userType && userMetaData.userMifirma.userType.id === Number(process.env.REACT_APP_USER_TYPE_COLABORADOR) || userMetaData.userMifirma.userType.id === Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR))) {
              this.setState({ userIsColaborator: true })
              let { firstName, firstLastName, secondLastName, phoneNumber, cellphoneNumber } = userMetaData.userA3Cloud
              if ((firstName === '') &&
                (firstLastName === '') &&
                (secondLastName === '') &&
                (phoneNumber === null || phoneNumber === '') &&
                (cellphoneNumber === null || cellphoneNumber === '')) {
                this.setState({ userColaboratorUpdateYourInfo: false })
              }
            }

            // Timer token session started
            this.localStorageService.timerSession(token)
            window.history.pushState('', document.title, window.location.pathname)

            if (contract && contract.data) {
              if (contract.data.contractExist === true || contract.data.userHadContracts === true) {
                this.setState({ userRegistered: true })
              }
            }

            // Save the user information of Logo and auth0-data
            let clientLogo = (userMetaData && userMetaData.clientLogo) ? userMetaData.clientLogo : null

            await this.localStorageService.setLocalStorageItem('clientLogo', clientLogo)
            await this.localStorageService.setLocalStorageItem('auth0-data', userMetaData.userAuth0)

            this.setState({ emailConfirmed: userMetaData.userAuth0.email_verified, userStartSesion: true })
            await this.setState({ userLogin: userMetaData.userAuth0.email, loading: false })
          }
        } else {
          await this.setState({ userLogin: token.email, loading: false })
          let data = await this.localStorageService.getLocalStorageItem('auth0-data')
          let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
          let promotion = await this.localStorageService.getLocalStorageItem('promotion')
          await this.localStorageService.clearLocalStorage()
          if (logo) await this.localStorageService.setLocalStorageItem('clientLogo', logo)
          if (data) await this.localStorageService.setLocalStorageItem('auth0-data', data)
          if (promotion) await this.localStorageService.setLocalStorageItem('promotion', promotion)
          this.setState({ userStartSesion: true, emailConfirmed: false })
        }

        if (!denyLogin) {
          let user = {}
          user.userToken = userToken
          user.userMetaData = userMetaData
          if (userMetaData) {
            modules = (userMetaData.userModules ? userMetaData.userModules : null)
            this.localStorageService.startLocalStorage(token, user, modules)
          }
          else {
            modules = null
            this.localStorageService.startLocalStorage(token, user, modules)
          }
        } else {
          await this.localStorageService.clearLocalStorage()
        }

        if (userToken) {
          this.setState({ auth0Exist: true })
        }

        this.setState({ isLogged: true, loading: false })
      } else if (existSignRequestOpen && existAllParameters) {
        const userData = await UserService.getUserPublic(email)
        if (userData.data && (!userData.data.userA3Cloud && !userData.data.userMifirma)) {
          this.setState({ loading: false, isValidUser: false })
          return
        }


        if (!userData.data.userA3Cloud.cellphoneNumber) {
          this.setState({ newUser: true, isValidUser: true, userEmail: userData.data.userMifirma.email })
        } else {
          this.setState({ newUser: false, isValidUser: true, userEmail: userData.data.userMifirma.email })
        }
        try {
          const apiLang = userData?.data?.userMifirma.language?.isoKey
          const preferredLanguage = (apiLang === 'en' || apiLang === 'es') ? apiLang : 'es'
          this.localStorageService.setLocalStorageItem('preferredLanguage', preferredLanguage)
          appI18n.changeLanguage(preferredLanguage)
        } catch (_) {
          this.localStorageService.setLocalStorageItem('preferredLanguage', 'es')
          appI18n.changeLanguage('es')
        }
        this.localStorageService.setLocalStorageItem('user', userData.data)
        this.setState({ loading: false })
      } else {
        this.redirectLogin()
        this.setState({ loading: false })
      }
    } catch (err) {
      this.redirectLogin()
      this.setState({ loading: false })
    }
  }

  handleButtonLogOut = async () => {
    let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
    let promotion = await this.localStorageService.getLocalStorageItem('promotion')
    await this.localStorageService.clearLocalStorage()
    if (promotion) await this.localStorageService.setLocalStorageItem('promotion', promotion ? promotion : '')
    this.auth0Service.logout()
  }


  render() {
    if (this.state.denyLogin) {
      return <VerifyContract
        contractStatus={this.state.contractStatus} />
    }
    if (this.state.loading === true) {
      return <SimpleLoading />
    } else if (this.state.userTypeServiceApi) {
      return (
        <UserTypeServiceAPI
          handleButtonLogOut={this.handleButtonLogOut}
        />
      )
    } else if (this.state.requestOTP) {
      return (
        <RequestOTPAction />
      )
    } else if (this.state.isQRDocsigned) {
      return (
        <QRDocSignedAction
          sessionId={this.state.sessionIdQR}
          hash={this.state.hashQR}
        />
      )
    } else if (this.state.isEmailChangepassword === true) {
      return <ChangePasswordEmailAction
        user={this.state.userInfoChangePassword}
        token={this.state.tokenInfoChangePassword}
      />
    } else if (this.state.userStartSesion === true &&
      this.state.emailConfirmed === false) {
      return <EmailConfirmation
        {...this.state}
        onSendVerificationEmail={this.onSendVerificationEmail}
        onLoadEmailConfirmation={this.onLoadEmailConfirmation}
        notification={this.notification}
        onCloseOpenModal={this.onCloseOpenModal}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        handleButtonLogOut={this.handleButtonLogOut}
      />
    } else if (this.state.isLogged &&
      !this.state.userRegistered &&
      !this.state.userIsInvited &&
      this.state.auth0Exist) {
      return <RegistrationAction
        {...this.state}
        onRegisterEnd={this.onRegisterEnd}
        onGoToMenu={this.onGoToMenu}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleRegisterCompleted={this.toggleRegisterCompleted}
      />
    } else if (this.state.showNewUserOnboardingView) {
      return <NewUserOnboardingAction />
    } else if (this.state.userStartSesion === true &&
      this.state.isLogged &&
      this.state.userRegistered === true &&
      this.state.userIsColaborator === true &&
      this.state.userColaboratorUpdateYourInfo === false &&
      this.state.userIsInvited === false &&
      this.state.userInvitedUpdateYourInfo === true) {
      return <RegisterUserCollaboratorAction />
    } else if (this.state.userStartSesion === true &&
      this.state.isLogged &&
      this.state.userRegistered) {
      return <AppAction
        onInvitedRedirectRegister={this.onInvitedRedirectRegister}
      />
    } else if (this.state.unauthorized) {
      return <div>unauthorized</div>
    } else if (this.state.withoutPasswordSign && !this.state.newUser && !this.state.isValidUser) {
      return <WithoutPasswordScreen />
    } else if (this.state.withoutPasswordSign) {
      return <InvitedWoutPasswordAction id={this.state.idSign} email={this.state.userEmail} />
    } else if (this.state.withoutPasswordSign && this.state.newUser && this.state.isValidUser) {
      return <RegisterUserInvitedAction idSign={this.state.idSign} withoutPasswordSign={this.state.withoutPasswordSign} email={this.state.userEmail} />
    } else if (this.state.userStartSesion === false) {
      return <LoginAction />
    } else {
      return <SimpleLoading />
    }
  }
}

const IndexComponentContainer = (props) => {
  let { t, i18n } = useTranslation()
  return (
    <IndexComponent
      {...props}
      t={t}
      i18n={i18n}
    />
  )
}

export { IndexComponentContainer as default }